import React, { useId, useRef, useState } from "react";
import { IoInformationCircleOutline } from "react-icons/io5";
import {
  acceptOddsChangesInfo,
  acceptOddsChangesLabel,
} from "../../utility/entryCopy";

const TIP_WIDTH = 248;

/** Checkbox + info for Accept Odds Changes (default off). */
export default function AcceptOddsChangesControl({ checked, onChange }) {
  const info = acceptOddsChangesInfo();
  const tipId = useId();
  const buttonRef = useRef(null);
  const [tipStyle, setTipStyle] = useState(null);

  const placeTip = () => {
    const button = buttonRef.current;
    const rect = button?.getBoundingClientRect();
    const row = button?.closest(".accept-odds-changes")?.getBoundingClientRect();
    if (!rect || !row) return;
    const width = Math.min(TIP_WIDTH, Math.max(160, row.width), window.innerWidth - 16);
    const left = Math.max(8, Math.min(row.left, window.innerWidth - width - 8));
    const openAbove = rect.top > 140;
    setTipStyle(
      openAbove
        ? {
            position: "fixed",
            width,
            left,
            top: rect.top - 8,
            transform: "translateY(-100%)",
          }
        : {
            position: "fixed",
            width,
            left,
            top: rect.bottom + 8,
          }
    );
  };

  const showTip = () => placeTip();
  const hideTip = () => setTipStyle(null);

  return (
    <div className="accept-odds-changes d-flex align-items-center gap-2 mb-2">
      <label className="fs12 d-flex align-items-center gap-2 mb-0 cursor-pointer">
        <input
          type="checkbox"
          checked={Boolean(checked)}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        <span>{acceptOddsChangesLabel()}</span>
      </label>
      <button
        ref={buttonRef}
        type="button"
        className="accept-odds-changes__info"
        aria-label="About Accept Odds Changes"
        aria-describedby={tipStyle ? tipId : undefined}
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
        onFocus={showTip}
        onBlur={hideTip}
      >
        <IoInformationCircleOutline className="fs14" aria-hidden="true" />
      </button>
      {tipStyle ? (
        <span
          id={tipId}
          role="tooltip"
          className="accept-odds-changes__tip"
          style={tipStyle}
        >
          {info}
        </span>
      ) : null}
    </div>
  );
}
